var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 0.5V1.52539L3.6875 5.90039V11L6.3125 9.03125V5.90039L9.8125 1.52539V0.5H0.1875ZM1.18555 1.375H8.81445L5.66992 5.3125H4.33008L1.18555 1.375ZM4.5625 6.1875H5.4375V8.59375L4.5625 9.25V6.1875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.078c41b3ecadeb8956206609f7ba728e.svg";
export { ForwardRef as ReactComponent };